module.exports = __webpack_public_path__ + "static/img/logo.f750eff1.svg";